import { render } from "./HomePage.vue?vue&type=template&id=15b81a78&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=15b81a78&scoped=true&lang=css"

import exportComponent from "/home/regie/projects-2.0/cia-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b81a78"]])

export default __exports__